__turbopack_context__.v({
  "button-group": "R9aHHq_button-group",
  "info": "R9aHHq_info",
  "portal": "R9aHHq_portal",
  "quiz": "R9aHHq_quiz",
  "quiz-section": "R9aHHq_quiz-section",
  "summary": "R9aHHq_summary",
  "summary-section": "R9aHHq_summary-section",
});
